import { ResponseError } from "@nimble/react-requests/api-clients/fetch-config";
import { buildErrorMessage } from "@nimble/react-requests/helpers/error-message";
import { useMutation } from "@tanstack/react-query";

import coreApiClient from "@/lib/api-clients/core-api-client";
import { AUTH_ERROR_MESSAGES } from "@/lib/constants/auth-messages";
import { OTPThrottleError } from "@/lib/errors/otp-throttle-error";
import { JSONValue } from "@/lib/types";

export default function useOTPRequest() {
  return useMutation({
    mutationFn: async (email: string) => {
      const result = await coreApiClient
        .postApiAuthOtpRequest({
          body: { email },
        })
        .catch((error) => {
          if (error instanceof ResponseError) {
            const throttleError = OTPThrottleError.fromResponseError(
              error as ResponseError<JSONValue>,
            );
            if (throttleError) {
              throw throttleError;
            }
          }

          throw new Error(
            buildErrorMessage(error, AUTH_ERROR_MESSAGES.otpRequestFailed),
          );
        });
      return result.data;
    },
  });
}
